// A loose map panel (Shot Details, Pass Summary) — canvas/map-panels.ts. Its map draws into the slot
// here; this module only offers the slot, and outlines the map while the pointer is over it (and
// itself while the pointer is over the map), so it's clear which map it serves.

import { useEffect, useRef } from "react";
import type { ProtoModuleProps } from "./bridge.js";
import { panelLinkOf, panelPartner, setPanelSlot } from "../canvas/map-panels.js";

export function MapPanelModule({ mod }: ProtoModuleProps) {
  const slot = useRef<HTMLDivElement>(null);
  const link = panelLinkOf(mod);

  useEffect(() => {
    if (!link || !slot.current) return;
    setPanelSlot(link, slot.current);
    return () => setPanelSlot(link, null);
  }, [link]);

  // Hovering either one outlines the other.
  useEffect(() => {
    const outline = (on: boolean) => () => {
      const map = panelPartner(mod);
      map?.classList.toggle("panel-link-hover", on);
    };
    const mark = (on: boolean) => () => mod.classList.toggle("panel-link-hover", on);
    const map = panelPartner(mod);
    const enter = outline(true);
    const leave = outline(false);
    const mapEnter = mark(true);
    const mapLeave = mark(false);
    mod.addEventListener("mouseenter", enter);
    mod.addEventListener("mouseleave", leave);
    map?.addEventListener("mouseenter", mapEnter);
    map?.addEventListener("mouseleave", mapLeave);
    return () => {
      mod.removeEventListener("mouseenter", enter);
      mod.removeEventListener("mouseleave", leave);
      map?.removeEventListener("mouseenter", mapEnter);
      map?.removeEventListener("mouseleave", mapLeave);
      map?.classList.remove("panel-link-hover");
      mod.classList.remove("panel-link-hover");
    };
  }, [mod, link]);

  return (
    <div className="map-panel-module" ref={slot}>
      {!link && <div className="event-details-empty">This panel has lost its map.</div>}
    </div>
  );
}
